import { getSpecies } from './contentRegistry';

// Resolve a species pick into a structured contribution to the character draft.
//
// Returns null when the species id is unknown so the caller can show an
// empty-state instead of crashing.
//
// `chosenAbilityBonuses` is the player's allocation when the species ASI uses
// `kind: 'choose'`. Phase 2 archetypes pre-allocate; later phases let players
// edit.

export const applySpecies = (speciesId, chosenAbilityBonuses = null) => {
  const species = getSpecies(speciesId);
  if (!species) return null;

  let abilityBonuses = {};
  if (species.abilityScoreIncreases?.kind === 'fixed') {
    abilityBonuses = species.abilityScoreIncreases.increases || {};
  } else if (species.abilityScoreIncreases?.kind === 'choose') {
    abilityBonuses = chosenAbilityBonuses || {};
  }

  const senses = [];
  const advantages = [];
  const immunities = [];
  const proficiencies = [];
  let speedBonus = 0;

  for (const trait of species.traits || []) {
    for (const effect of trait.effects || []) {
      switch (effect.kind) {
        case 'sense':
          senses.push({ value: effect.value, source: trait.name });
          break;
        case 'advantage':
          advantages.push({ on: effect.on, source: trait.name });
          break;
        case 'immunity':
          immunities.push({ value: effect.value, source: trait.name });
          break;
        case 'speed-bonus':
          speedBonus += effect.value || 0;
          break;
        case 'skill-proficiency':
          proficiencies.push({ kind: 'skill', value: effect.skill, source: trait.name });
          break;
        case 'language':
          // languages are flattened below from species.languages too
          break;
        default:
          break;
      }
    }
  }

  return {
    speciesId: species.id,
    speciesName: species.name,
    size: species.size,
    speed: species.speed + speedBonus,
    creatureType: species.creatureType || 'humanoid',
    abilityBonuses,
    traits: species.traits || [],
    languages: species.languages || [],
    senses,
    advantages,
    immunities,
    proficiencies,
  };
};
